export var PinStatus;
(function (PinStatus) {
    PinStatus["NONE"] = "NONE";
    PinStatus["SET"] = "SET";
    PinStatus["LOCKED"] = "LOCKED";
    PinStatus["RESET_REQUIRED"] = "RESET_REQUIRED";
})(PinStatus || (PinStatus = {}));
//# sourceMappingURL=pin.types.js.map